import { render, staticRenderFns } from "./AssetReviewStepAccess.vue?vue&type=template&id=d42d74f2&"
import script from "./AssetReviewStepAccess.vue?vue&type=script&lang=js&"
export * from "./AssetReviewStepAccess.vue?vue&type=script&lang=js&"
import style0 from "./AssetReviewStepAccess.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AssetReviewStepAccess.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d42d74f2')) {
      api.createRecord('d42d74f2', component.options)
    } else {
      api.reload('d42d74f2', component.options)
    }
    module.hot.accept("./AssetReviewStepAccess.vue?vue&type=template&id=d42d74f2&", function () {
      api.rerender('d42d74f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/AssetReview/ReviewSteps/AssetReviewStepAccess.vue"
export default component.exports